"use client";

import { subscribeToRecipe } from "@/lib/recipe-service";
import type { Recipe } from "@/lib/types";
import type { FirestoreError } from "firebase/firestore";
import { useEffect, useState } from "react";

type RecipeState = {
  recipe: Recipe | null;
  loading: boolean;
  error: string | null;
};

export function useRecipe(recipeId: string | null | undefined): RecipeState {
  const [state, setState] = useState<RecipeState>({ recipe: null, loading: true, error: null });

  useEffect(() => {
    if (!recipeId) {
      return undefined;
    }

     
    setState((prev) => ({ ...prev, loading: true, error: null }));

    const unsubscribe = subscribeToRecipe(
      recipeId,
      (recipe) => {
        if (!recipe) {
          setState({ recipe: null, loading: false, error: null });
          return;
        }

        setState({ recipe, loading: false, error: null });
      },
      (error: FirestoreError) => {
        console.error("Failed to load recipe", error);
        setState({ recipe: null, loading: false, error: "Failed to load recipe." });
      },
    );

    return unsubscribe;
  }, [recipeId]);

  if (!recipeId) {
    return { recipe: null, loading: false, error: null };
  }

  return state;
}
